import React from 'react';
import { Field, RichText as JssRichText } from '@sitecore-jss/sitecore-jss-nextjs';
import { PageSection, PageSectionContent, RteWrapper } from '@greystar/designsystem';
import { RichTextProps } from '../../../src/component-props';

const allowedTags = new Set(['h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'p', 'a', 'ul', 'ol', 'li']);

const RichTextContent = ({
  text,
  id,
  styles = '',
  Tag,
}: {
  text: Field<string>;
  id?: string;
  styles?: string;
  Tag: keyof JSX.IntrinsicElements;
}) => (
  <div className={`component rich-text ${styles}`} id={id}>
    <div className="component-content">
      <RteWrapper>
        <Tag>
          <JssRichText field={text} />
        </Tag>
      </RteWrapper>
    </div>
  </div>
);

const RichText = ({ params = {}, fields = {} }: RichTextProps): JSX.Element | null => {
  const { tag = 'div', styles = '', RenderingIdentifier: id } = params;
  const { Text: text, bottomFlushed, topFlushed, isContentWrapped } = fields;

  if (!text) return null;

  const Tag = (allowedTags.has(tag) ? tag : 'div') as keyof JSX.IntrinsicElements;

  const content = <RichTextContent text={text} id={id} styles={styles.trim()} Tag={Tag} />;

  return isContentWrapped?.value ? (
    <PageSection isBottomFlushed={bottomFlushed?.value} isTopFlushed={topFlushed?.value}>
      <PageSectionContent>{content}</PageSectionContent>
    </PageSection>
  ) : (
    content
  );
};

export default RichText;
